// extracted by mini-css-extract-plugin
export var fullGrid = "_3e-3";
export var pdpPreviewContainer = "_3e-1";
export var previewContainer = "_3e-0";
export var togglePreviewContainer = "_3e-2";